import * as Sqrl from 'squirrelly';

var processDefaultValidationError = function (initialContent, postProcessingParameters) {
    var message = (postProcessingParameters === null || postProcessingParameters === void 0 ? void 0 : postProcessingParameters.message) || '';
    return Sqrl.render(initialContent, { message: message });
};

export { processDefaultValidationError };
//# sourceMappingURL=processDefaultValidationError.esm.js.map
